import {putMethod} from '~/api'

async function put(request) {
    return await putMethod('/api/updatePackageTourPrice', request)
}

export {put}
